<template>
  <div class="events-block">
    <div class="justify-content-between">
      <div class="events-list">
        <span class="event">
          <span class="date">
            August 7-12, 2016
          </span>
          <span class="name">
            Oncotarget journal is a Sponsor of Rare Cells in Cordon Conference, South Hadley, MA.
          </span>
        </span>
        <span class="divider-vertical"></span>
        <span class="event">
          <span class="date">
            September 25-28, 2016
          </span>
          <span class="name">
            Circulation Cordon Research Conference, South Hadley, MA.
          </span>
        </span>
      </div>
      <span class="divider-vertical"></span>
      <div class="link">
        <router-link :to="{name: 'archivedIssues'}">View Archives ></router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'header-events-block'
  }
</script>

<style lang="scss" scoped>
  .events-block {
    border-top: 1px solid $page-header-border;
    background-color: $page-header-bg;
    padding: 10px 15px;
    margin-bottom: 10px;
    font-family: 'Merriweather';
    font-style: italic;
    font-size: 14px;
    .router-link-active {
      text-decoration: none;
      cursor: default;
    }
    .link {
      text-align: end;
      text-decoration: underline;
      line-height: 40px;
    }
    >div {
      display: flex;
      align-items: center;
      .events-list {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .event {
          padding: 0px 20px;
          .date {
            font-style: italic;
            color: $primary-color;
          }
          .name {
            text-decoration: underline;
            color: $accent-color-2;
          }
        }
      }
      .link {
        min-width: 110px;
        white-space: nowrap;
      }
    }
  }
</style>

<style lang="scss">
  @media(max-width: 767px) {
    .events-block {
      position: absolute;
      left: 0;
      right: 0;
    }
    .events-block + div {
      padding-top: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderEventsBlockComponent.vue?ada5334a